$(document).ready(function(){
  $('.click-to-play').click(function(){
  	$(this).siblings('iframe.slideshow__video').css('display','block');
    $(this).css('z-index','1');
    $(this).siblings('.slideshow__video-control--close').show().css({'opacity':'1','visibility':'visible'})
  });
  $('.reveal-slider .slideshow__video-control--close').click(function(){
    $(this).siblings('iframe.slideshow__video').hide();
    $(this).siblings('.click-to-play').css('z-index','4');
    $(this).hide().css({'opacity':'0','visibility':'hidden'})
  });
  $('.slideshow-secondary').slick({
      accessibility: true,
      arrows: false,
      dots: false,
      fade: false,
      draggable: false,
      touchThreshold: 20,
      autoplay: false,
      autoplaySpeed: false,
      infinite: true
  });
  
  $('.slideshow-main').on('beforeChange', function(event, slick, currentSlide) {
 	$(this).parent().parent().siblings('.slideshow-secondary-container').find('.slideshow-secondary').slick('slickGoTo', currentSlide+1);
 });
})

// CD CODE

// $(window).on('load', function(){
//   if($('.custom_popup').length){
//     setTimeout(function(){ $('.custom_popup').addClass('close_popup');}, 2000);
//     setTimeout(function(){ $('.custom_popup').removeClass('close_popup'); }, 10000);
//   }
// });

// $(document).on('click', '.close_popup_btn', function(){
//   $('.custom_popup').removeClass('close_popup');
// });

// $(document).on("click", function(e) {
//   if(!$('.popup_wrapper').has(e.target).length){
//     $('.custom_popup').removeClass('close_popup');
//   }
// });
// $(window).on('load', function(){
//   // Check if the popupShown cookie is not set or if it's not set to "true"
//   if (!getCookie("popupShown") || getCookie("popupShown") !== "true") {
//     if($('.custom_popup').length){
//       // Display the popup after 2 seconds
//       setTimeout(function(){ 
//         $('.custom_popup').addClass('close_popup');
//         // Remove the popup after 7 seconds
//         setTimeout(function(){ 
//           $('.custom_popup').removeClass('close_popup'); 
//         }, 7000);
//       }, 2000);
//     }
//   }
// });

// $(document).on('click', '.close_popup_btn', function(){
//   $('.custom_popup').removeClass('close_popup');
//   // Set the cookie to indicate that the popup has been shown
//   setCookie("popupShown", "true", 1); // Set the cookie to expire in 1 day
// });

// $(document).on("click", function(e) {
//   if(!$('.popup_wrapper').has(e.target).length){
//     $('.custom_popup').removeClass('close_popup');
//   }
// });

// // Function to set a cookie
// function setCookie(name, value, days) {
//   var expires = "";
//   if (days) {
//     var date = new Date();
//     date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
//     expires = "; expires=" + date.toUTCString();
//   }
//   document.cookie = name + "=" + (value || "") + expires + "; path=/";
// }

// // Function to get a cookie by name
// function getCookie(name) {
//   var nameEQ = name + "=";
//   var ca = document.cookie.split(';');
//   for(var i=0;i < ca.length;i++) {
//     var c = ca[i];
//     while (c.charAt(0)==' ') c = c.substring(1,c.length);
//     if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
//   }
//   return null;
// }
$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 100) {
        $(".fixed-link-button").addClass("darkHeader-pt");
    } else {
        $(".fixed-link-button").removeClass("darkHeader-pt");
    }
});
